// postReducer.js

const initialState = {
  slug: "",
  category: "software",
  image: "",
  title: "",
  content: "",
  blogImage : ""
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_SLUG":
      return {
        ...state,
        slug: action.payload,
      };
    case "UPDATE_CATEGORY":
      return {
        ...state,
        category: action.payload,
      };
    case "UPDATE_IMAGE":
      return {
        ...state,
        image: action.payload,
      };
      case "UPDATE_BLOG_IMAGE":
        return {
          ...state,
          blogImage: action.payload,
        };
    case "UPDATE_TITLE":
      return {
        ...state,
        title: action.payload,
      };
    case "UPDATE_CONTENT":
      return {
        ...state,
        content: action.payload,
      };
    default:
      return state;
  }
};

export default blogReducer;
